const AuthWrapper = ({ children }) => {
  return <>{children}</>;
};

export default AuthWrapper;